import React, { useState } from "react";
import PageLayout, { SectionReveal } from "../components/PageLayout";
import PageHero from "../components/PageHero";
import PageBanner from "../components/PageBanner";
import { MapPin, Mail, Phone, Clock } from "lucide-react";

const ContactPage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const body = `Ad Soyad: ${name}\nE-posta: ${email}\n\n${message}`;
    window.location.href = `mailto:hello@verasist.ai?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  const hero = (
    <PageHero
      eyebrow="İletişim"
      title="Bizimle iletişime geçin"
      subtitle="Sorularınız, önerileriniz veya iş birliği talepleriniz için bize ulaşın. Size en kısa sürede dönüş yapacağız."
    />
  );

  return (
    <PageLayout hero={hero}>
      <PageBanner src="/contact.png" alt="Verasist iletişim" height="300px" />
      <SectionReveal>
        <section className="py-16 px-6">
          <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12">
            {/* Contact Info */}
            <div>
              <h2 className="text-[22px] font-bold mb-6" style={{ color: "var(--fg)" }}>Bize Ulaşın</h2>
              <div className="space-y-5">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: "rgba(75,111,212,0.12)", color: "var(--brand-cyan)" }}>
                    <MapPin size={18} />
                  </div>
                  <div>
                    <h3 className="text-[14px] font-semibold" style={{ color: "var(--fg)" }}>Adres</h3>
                    <p className="text-[14px] mt-1" style={{ color: "var(--fg)", opacity: 0.8 }}>
                      Maslak Mah. AOS 55. Sokak No:2<br />
                      Maslak 42 Ofis Kuleleri, Kat:12<br />
                      34398 Sarıyer / İstanbul
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: "rgba(255,122,122,0.12)", color: "#FF7A7A" }}>
                    <Mail size={18} />
                  </div>
                  <div>
                    <h3 className="text-[14px] font-semibold" style={{ color: "var(--fg)" }}>E-posta</h3>
                    <p className="text-[14px] mt-1" style={{ color: "var(--fg)", opacity: 0.8 }}>
                      <a href="mailto:info@verasist.ai" style={{ color: "var(--brand-cyan)" }}>hello@verasist.ai</a><br />
                      Satış: <a href="mailto:satis@verasist.ai" style={{ color: "var(--brand-cyan)" }}>hello@verasist.ai</a><br />
                      Destek: <a href="mailto:destek@verasist.ai" style={{ color: "var(--brand-cyan)" }}>hello@verasist.ai</a>
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: "rgba(20,184,166,0.12)", color: "#14B8A6" }}>
                    <Phone size={18} />
                  </div>
                  <div>
                    <h3 className="text-[14px] font-semibold" style={{ color: "var(--fg)" }}>Telefon</h3>
                    <p className="text-[14px] mt-1" style={{ color: "var(--fg)", opacity: 0.8 }}>
                      <a href="tel:+902662391410" style={{ color: "var(--brand-cyan)" }}>+90 (266) 239 14 10</a>
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: "rgba(139,92,246,0.12)", color: "#8B5CF6" }}>
                    <Clock size={18} />
                  </div>
                  <div>
                    <h3 className="text-[14px] font-semibold" style={{ color: "var(--fg)" }}>Çalışma Saatleri</h3>
                    <p className="text-[14px] mt-1" style={{ color: "var(--fg)", opacity: 0.8 }}>
                      Pazartesi - Cuma: 09:00 - 18:00<br />
                      Cumartesi: 10:00 - 14:00
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div>
              <h2 className="text-[22px] font-bold mb-6" style={{ color: "var(--fg)" }}>Mesaj Gönderin</h2>
              <form className="space-y-5" onSubmit={handleSubmit}>
                <div className="grid sm:grid-cols-2 gap-5">
                  <div>
                    <label className="block text-[13px] font-medium mb-1.5" style={{ color: "var(--fg)" }}>Ad Soyad</label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className="w-full px-4 py-2.5 rounded-xl text-[14px] transition-colors duration-200 outline-none"
                      style={{ background: "var(--card-bg)", border: "1px solid var(--border)", color: "var(--fg)" }}
                      placeholder="Adınız Soyadınız"
                    />
                  </div>
                  <div>
                    <label className="block text-[13px] font-medium mb-1.5" style={{ color: "var(--fg)" }}>E-posta</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full px-4 py-2.5 rounded-xl text-[14px] transition-colors duration-200 outline-none"
                      style={{ background: "var(--card-bg)", border: "1px solid var(--border)", color: "var(--fg)" }}
                      placeholder="ornek@firma.com"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-[13px] font-medium mb-1.5" style={{ color: "var(--fg)" }}>Konu</label>
                  <input
                    type="text"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    className="w-full px-4 py-2.5 rounded-xl text-[14px] transition-colors duration-200 outline-none"
                    style={{ background: "var(--card-bg)", border: "1px solid var(--border)", color: "var(--fg)" }}
                    placeholder="Mesajınızın konusu"
                  />
                </div>
                <div>
                  <label className="block text-[13px] font-medium mb-1.5" style={{ color: "var(--fg)" }}>Mesajınız</label>
                  <textarea
                    rows={5}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    className="w-full px-4 py-2.5 rounded-xl text-[14px] transition-colors duration-200 outline-none resize-none"
                    style={{ background: "var(--card-bg)", border: "1px solid var(--border)", color: "var(--fg)" }}
                    placeholder="Mesajınızı buraya yazın..."
                  />
                </div>
                <button
                  type="submit"
                  className="w-full py-3 rounded-full font-semibold text-[14px] transition-all duration-200"
                  style={{ background: "var(--brand-navy)", color: "#fff" }}
                >
                  Gönder
                </button>
              </form>
            </div>
          </div>
        </section>
      </SectionReveal>
    </PageLayout>
  );
};

export default ContactPage;
